<template lang="pug">
div.wrap
  svg(:style="{width: `${params.width}px`, height: `${params.height}px`}", :id="params.svgName")
  .tooltip(style="opacity:0;" :id="`${params.svgName}_toolTip`")
</template>

<script>
/* eslint-disable no-underscore-dangle */
import * as d3 from 'd3';
import * as qs from 'qs';

export default {
  name: 'D3',
  props: {
    params: {
      type: Object,
      default: null,
    },
  },
  inject: ['style'],
  data () {
    return {
      locale: null,
      elements: {
        focus: {},
        context: {},
        datafocus: [],
        datacontext: [],
        timestampUnderMouse: 0,
        dataUnderMouse: [],
        z: 0,
        from: 0,
        to: 100,
      },
      selectedItemsVisible: null,
      seriesWidth: null,
      ImageDrainsFills: null,
      ArrayAxisY: [],
      sizeImage: 25,
      svg: null,
      x: null,
      xm: null,
      xAxis: null,
      xAxisM: null,
      margin: null,
      margin2: null,
      height: null,
      height2: null,
      drains: [],
      fills: [],
      noinfo: [],
      rides: [],
      zoom: null,
      brush: null,
      reportTime: 0,
    };
  },
  computed: {
    axis () {
      return this.params.series.axis;
    },
  },
  watch: {
    axis: {
      handler (sensors) {
        sensors.forEach((_item) => {
          const item = _item;
          if (item.selected !== item.visible) {
            if (item.selected) {
              if (item.init) {
                this.getUpdateLine(this.selectedItems().id, this.seriesWidth, this.elements.from, this.elements.to, item);
              } else {
                this.getInitLine(this.selectedItems().id, this.seriesWidth, 0, 100, item);
              }
            } else {
              // console.debug('Поменялся axis на: ', sensors);
              this.createAxisY(item);
              this.visibleElements(item, item.index + 1);
            }
            item.visible = item.selected;
          }
        });
      },
      deep: true,
    },
  },
  mounted () {
    // console.debug('mounted D3');
    if (this.params.loadDataUrl === undefined) {
      console.info('You must define parameter "loadDataUrl". For track it must be "/Tracks/GetChartPoints" ');
    }
    this.reportTime = this.params.svgName === 'reportingSVG' ? new Date().getTimezoneOffset() * 60000 : 0;
    const localeJS = {
      dateTime: '%A, %e %B %Y г. %X',
      date: '%d.%m.%Y',
      time: '%H:%M:%S',
      periods: ['AM', 'PM'],
      days: ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'],
      shortDays: ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
      months: ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'],
      shortMonths: ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'],
    };
    d3.timeFormatDefaultLocale(localeJS);
    this.locale = d3.timeFormatLocale(localeJS);
    this.selectedItemsVisible = this.params.series;
    // console.debug(this.selectedItemsVisible);

    this.svg = d3.select(`#${this.params.svgName}`);

    if (!this.svg.empty()) {
      if (this.params.height < 140) {
        console.info('слишком маленький размер высоты графика, установите больше');
        return;
      }
      this.margin = {
        top: 30,
        right: 40,
        bottom: 110,
        left: 40,
      };
      this.margin2 = {
        top: this.params.height - 70,
        right: 40,
        bottom: 30,
        left: 40,
      };
      this.seriesWidth = this.params.width - this.margin.left - this.margin.right;
      this.height = this.params.height - this.margin.top - this.margin.bottom;
      this.height2 = this.params.height - this.margin2.top - this.margin2.bottom;

      this.x = d3.scaleTime().range([0, this.seriesWidth]);
      this.xm = d3.scaleTime().range([0, this.seriesWidth]);

      this.xAxis = d3.axisBottom(this.x).tickFormat(this.multiFormat);
      this.xAxisM = d3.axisBottom(this.xm).tickFormat(this.multiFormat);

      this.drains = this.params.drains ?? [];
      this.fills = this.params.fills ?? [];
      this.noinfo = this.params.noinfo ?? [];
      this.rides = this.params.rides ?? [];

      this.svg.append('defs').append('clipPath')
        .attr('id', `clip${this.params.svgName}`)
        .append('rect')
        .attr('width', this.seriesWidth)
        .attr('height', this.height);

      this.ImageDrainsFills = this.svg.append('g')
        .attr('class', 'ImageDrainsFills')
        .attr('transform', `translate(${this.margin.left},${this.margin.top})`);

      this.elements.focus = this.svg.append('g')
        .attr('class', 'focus')
        .attr('transform', `translate(${this.margin.left},${this.margin.top})`);

      this.elements.context = this.svg.append('g')
        .attr('class', 'context')
        .attr('transform', `translate(${this.margin2.left},${this.margin2.top})`);

      this.brush = d3.brushX()
        .extent([[0, 0], [this.seriesWidth, this.height2]])
        .on('brush end', this.brushed);

      this.zoom = d3.zoom()
        .scaleExtent([1, Infinity])
        .translateExtent([[0, 0], [this.seriesWidth, this.height]])
        .extent([[0, 0], [this.seriesWidth, this.height]])
        .on('zoom', this.zoomed);

      this.getInitData(this.selectedItems().id, this.seriesWidth, 0, 100, this.selectedItems().axis);
    } else {
      console.info('svg element is empty or not found');
    }
  },
  methods: {
    selectedItems () {
      // console.debug(this.params.series.axis);
      return this.params.series;
    },
    multiFormat (date) {
      let format = null;
      if (d3.timeSecond(date) < date) {
        format = this.locale.format('.%L');
      } else if (d3.timeMinute(date) < date) {
        format = this.locale.format(':%S');
      } else if (d3.timeHour(date) < date) {
        format = this.locale.format('%H:%M');
      } else if (d3.timeDay(date) < date) {
        format = this.locale.format('%H:%M');
      } else if (d3.timeWeek(date) < date) {
        format = this.locale.format('%d.%m\r\n%H:%M');
      } else if (d3.timeMonth(date) < date) {
        format = this.locale.format('%d.%m');
      } else if (d3.timeYear(date) < date) {
        format = this.locale.format('%B');
      } else {
        format = this.locale.format('%Y');
      }
      return (format)(date);
    },
    compareZIndex (a, b) {
      return (b.z || 1) - (a.z || 1);
    },
    isNumeric (n) {
      return !Number.isNaN(parseFloat(n)) && Number.isFinite(n);
    },
    findClosestBinary (array, key, value, cmp) {
      let a = 0;
      let b = array.length - 1;
      let k;
      while (b - a > 1) {
        k = Math.floor((a + b) / 2);
        if ((cmp && cmp(value, array[k][key]) <= 0) || (!cmp && array[k][key] <= value)) {
          b = k;
        } else {
          a = k;
        }
      }
      return a;
    },
    brushed (event) {
      const s = event.selection || this.xm.range();
      this.x.domain(s.map(this.xm.invert, this.xm));
      this.selectedItems().axis.forEach((x, i) => this.elements.focus.select(`.line${i + 1}`).attr('d', x.line));
      this.elements.focus.select('.axis--x').call(this.xAxis);

      this.UpdateImage();

      if (event.sourceEvent) {
        this.svg.select('.zoom').call(this.zoom.transform, d3.zoomIdentity
          .scale(this.seriesWidth / (s[1] - s[0]))
          .translate(-s[0], 0));
      }
    },
    zoomed (event) {
      const t = event.transform;
      this.elements.t = t;

      this.x.domain(t.rescaleX(this.xm).domain());
      this.selectedItems().axis.forEach((x, i) => this.elements.focus.select(`.line${i + 1}`).attr('d', x.line));
      this.elements.focus.select('.axis--x').call(this.xAxis);

      this.UpdateImage();

      const mp = this.x.range().map(t.invertX, t);
      this.elements.from = (mp[0] - 1) / this.x.range()[1] * 100;
      this.elements.to = mp[1] / this.x.range()[1] * 100;
      this.elements.context.select('.brush').call(this.brush.move, this.x.range().map(t.invertX, t));

      setTimeout(() => {
        if (this.elements.z === 0) {
          this.elements.z = 1;
          this.getUpdateData(this.selectedItems().id, this.seriesWidth, this.elements.from, this.elements.to, this.selectedItems().axis);
        } else {
          this.elements.z += 1;
        }
      }, 100);
    },
    buildChart (sensors) {
      this.x.domain(d3.extent(this.elements.datafocus, d => new Date(d[0] * 1000 + this.reportTime)));
      this.xm.domain(this.x.domain());

      this.GetDrainsFills();
      // Ось Х
      this.elements.focus.append('g')
        .attr('class', 'axis axis--x')
        .attr('transform', `translate(0,${this.height})`)
        .call(this.xAxis);

      // Ось Х миникарты
      this.elements.context.append('g')
        .attr('class', 'axis axis--x')
        .attr('transform', `translate(0,${this.height2})`)
        .call(this.xAxisM);

      this.elements.focus.append('g')
        .attr('class', 'seriesPlace');

      // Оси Y. Плейсхолдер
      this.elements.focus.append('g')
        .attr('class', 'yAxises');

      this.addSeries({
        name: '_timestamp',
        color: 'white',
        selected: false,
      }, 0);
      this.elements.focus.select('.seriesPlace').select('.line0').style('display', 'none');
      this.svg.select('.ImageDrainsFills').style('display', 'block');

      // Делаем сортировку очередности отображения линий графика и отображаем
      const resortedSensors = sensors.map((_sens, index) => {
        const sens = _sens;
        sens.index = index;
        return sens;
      });
      // console.debug(resortedSensors);
      resortedSensors.sort(this.compareZIndex).map(item => this.addSeries(item, item.index + 1));
      // console.debug(resortedSensors);

      // console.debug('Строится график: ', this.selectedItems().axis);
      this.selectedItems().axis.forEach((sensor) => {
        if (sensor.selected) {
          this.createAxisY(sensor);
        }
        this.visibleElements(sensor, sensor.index + 1);
      });

      this.elements.context.append('g')
        .attr('class', 'brush')
        .call(this.brush)
        .call(this.brush.move, this.x.range());
      const mouseG = this.svg.append('g')
        .attr('class', 'mouse-over-effects');

      this.svg.append('rect')
        .attr('class', 'zoom')
        .attr('width', this.seriesWidth)
        .attr('height', this.height)
        .style('cursor', 'ew-resize')
        .style('fill', 'none')
        .style('pointer-events', 'all')
        .attr('transform', `translate(${this.margin.left},${this.margin.top})`)
        .call(this.zoom);

      mouseG.append('path') // this is the black vertical line to follow mouse
        .attr('class', 'mouse-line')
        .style('stroke', 'black')
        .style('stroke-width', '1px')
        .style('opacity', '0');

      const lines = document.querySelectorAll('path[class ^= "line"]');
      const mousePerLine = mouseG.selectAll('.mouse-per-line')
        .data(d3.range(lines.length))
        .enter()
        .append('g')
        .attr('class', 'mouse-per-line')
        .attr('pointer-events', 'none');

      // the circle
      mousePerLine.append('circle')
        .attr('r', 7)
        .style('stroke', d => 'red')
        .style('fill', 'none')
        .style('stroke-width', '1px')
        .style('opacity', '0');

      this.svg.select('rect.zoom')
        .on('mouseenter', () => {
          this.svg.select('.mouse-line')
            .style('opacity', '1');
        })
        .on('mouseleave', () => {
          this.svg.select('.mouse-line')
            .style('opacity', '0');
        })
        .on('mousemove', (event) => { // mouse moving over canvas
          const mouse = d3.pointer(event);
          const tt = d3.select(`#${this.params.svgName} + div.tooltip`);
          // move the vertical line
          this.svg.select('.mouse-line')
            .attr('d', () => {
              let dv = `M${mouse[0] + this.margin.left}, ${this.height + this.margin.top}`;
              dv += ` ${mouse[0] + this.margin.left},${this.margin.top}`;
              return dv;
            });
          // position the tooltip window
          tt.transition()
            .duration(100)
            .style('opacity', 0.95);
          const tthtml = this.selectedItems().axis.map((x, i) => {
            if (x.selected) {
              return (
                `<div id="y${i}" style="color:${x.color}; display: flex; justify-content: space-between;">
                  <div>${this.params.svgName === 'trackSVG' ? x.name : x.text}: </div>
                  <div style="font-weight: bold;" id='chart_tooltip_value${i}'></div>
                </div>`
              );
            }
            return undefined;
          });
          // Разворачиваем всплывающее окно по оси Х, если оно выходит на правую половину графика
          let ttLeft = 0;
          if (mouse[0] > this.seriesWidth / 2) {
            ttLeft = mouse[0] + this.margin.left - 15 - tt.node().getBoundingClientRect().width;
          } else {
            ttLeft = mouse[0] + this.margin.left + 15;
          }

          tt.html(`<h5 class="XValue" style="display: flex; justify-content: center; background: lightgray;">X value:</h5>${tthtml.join('')}`)
            .style('left', `${ttLeft}px`)
            .style('top', `${mouse[1] + this.margin.top - 25}px`);
          let beginning = 0;
          let end = lines[0].getTotalLength();
          let target = null;
          let pos;
          while (true) {
            target = Math.floor((beginning + end) / 2);
            pos = lines[0].getPointAtLength(target);
            if ((target === end || target === beginning) && pos.x !== mouse[0]) {
              break;
            }
            if (pos.x > mouse[0]) {
              end = target;
            } else if (pos.x < mouse[0]) {
              beginning = target;
            } else {
              break; // position found
            }
          }

          let v = this.findClosestBinary(this.elements.datafocus, 0, this.x.invert(pos.x), (a, b) => (a - new Date(b * 1000 + this.reportTime)));
          const c = this.x.invert(pos.x);
          if (v + 1 < this.elements.datafocus.length && Math.abs(c - new Date(this.elements.datafocus[v][0] * 1000 + this.reportTime)) > Math.abs(c - new Date(this.elements.datafocus[v + 1][0] * 1000 + this.reportTime))) {
            v += 1;
          }

          [this.elements.timestampUnderMouse] = this.elements.datafocus[v];
          this.elements.dataUnderMouse = this.elements.datafocus[v];

          lines.forEach((x, i) => {
            let value = this.elements.datafocus[v][i + 1];
            if (value && value.toFixed) {
              value = value.toFixed(2);
              if (value.indexOf('.') > 0) {
                while (value.endsWith('0')) {
                  value = value.substr(0, value.length - 1);
                }
              }
              if (value.endsWith('.')) {
                value = value.substr(0, value.length - 1);
              }
            }
            // выводим значения линий графика во всплывающем окне
            if (this.selectedItems().axis[i] && this.selectedItems().axis[i].y1 && this.selectedItems().axis[i].selected) {
              tt.select(`div#chart_tooltip_value${i}`).text(value);
            }
          });

          const d = new Date(this.elements.datafocus[v][0] * 1000 + this.reportTime);
          // выводим временную метку во всплывающем окне при наведении мыши
          tt.select('.XValue')
            .text(d.toLocaleString('ru-RU'));

          v = this.x(d);
          this.svg.select('.mouse-line').attr('d', () => `M${v + this.margin.left},${this.height + this.margin.top} ${v + this.margin.left},${this.margin.top}`);
        })
        .on('mouseout', () => {
          const tt = d3.select(`#${this.params.svgName} + div.tooltip`);
          tt.transition()
            .duration(100)
            .style('opacity', 0);
        })
        .on('click', () => {
          const timestamp = new Date(this.elements.timestampUnderMouse * 1000 + this.reportTime);

          if (this.params.getPointInfo) {
            const params = qs.stringify({
              id: this.selectedItems().id,
              timestamp,
            });
            this.$api.$get(`/v1${this.params.getPointInfo}/?${params}`).then((retdata) => {
              if (retdata) {
                const value = {
                  lat: retdata.Latitude,
                  lng: retdata.Longitude,
                };
                this.$store.commit('map/setCenter', value);
                this.$store.commit('tracks/setActivePoint', [value.lat, value.lng]);
                if (this.params.message) {
                  if (this.params.svgName === 'trackSVG') {
                    this.params.selectRowTrack?.(retdata.Index);
                  } else if (this.params.svgName === 'reportingSVG') {
                    this.params.selectRowTrack?.(retdata.Index);
                    //                    $.post('Reporting/GetInfoReport', { id: self.selectedItems().id }, function (report) {
                    //                        var track = ko.utils.arrayFilter(Denexy.LogExpert.TracksViewModel.gisTracks(), x => x.objectId == report.Id && x.begin == report.Begin && x.end == report.End && x.useRideDetector == false);
                    //                        if (track.length == 0) {
                    //                            Denexy.LogExpert.TracksViewModel.modal.createTrack(report.Id, report.Begin, report.End, false, null, null, true, selectRowTrack, moment(self.elements.timestampUnderMouse).datetime());
                    //                            track = Denexy.LogExpert.TracksViewModel.gisTracks();
                    //                        }
                    //                        $(document.querySelector('#menuHead > ul > li:nth-child(3) > a')).click();
                    //                        Denexy.LogExpert.TracksViewModel.selectTrack(track[0], true, selectRowTrack, moment(self.elements.timestampUnderMouse).datetime());
                    //                    });
                  }
                }
              }
            });
          }

          if (this.onclick) {
            this.onclick({
              id: this.selectedItems().id,
              timestamp: this.elements.timestampUnderMouse,
              data: this.elements.dataUnderMouse,
            });
          }
        });
    },
    selectRowTrack (pointId) {
      // $('#tabMessageTrack').tabs('option', 'active', 0);
      this.params.message.activeSubTab = 0;
      this.params.selectRowTrack(pointId);
    },
    getInitData (id, width, from, to, _sensors) {
      const sensors = _sensors;
      const filter = sensors.map((_sens, index) => {
        const sens = _sens;
        if (sens.selected) {
          sens.init = true;
        }
        sens.i = index;
        sens.visible = sens.selected;
        return sens;
      }).filter(x => x.selected);
      let sens = filter.map(x => x.name);
      let indexs = filter.map(x => x.i);
      if (sens.length === 0 && sensors.length !== 0) {
        sens = [sensors[0].name];
        sensors[0].init = true;
        indexs = [0];
      }
      const format = Array(sens.length + 1).fill(0);
      const params = qs.stringify({
        id,
        width,
        sensors: sens,
        from,
        to,
      }, { arrayFormat: 'indices' });

      this.$api.$get(`/v1${this.params.loadDataUrl}/?${params}`).then((retdata) => {
        this.clearChart();
        const data = Array(retdata.length);
        // console.debug(data);
        retdata.forEach((item, i) => {
          data[i] = Array(sensors.length + 1).fill(0);
          [data[i][0]] = item;
          indexs.forEach((j, k) => {
            if (this.isNumeric(item[k + 1])) {
              data[i][j + 1] = item[k + 1];
            } else {
              data[i][j + 1] = null;
              format[i] += 1;
            }
          });
        });

        format.forEach((f, i) => {
          if (i !== 0 && f !== 0) {
            if (f === retdata.length) {
              console.info(`Датчик ${sens[i - 1]} имеет не числовой формат данных`);
            }
          }
        });
        this.elements.datafocus = data;
        this.elements.datacontext = data;
        if (this.elements.datafocus != null && this.elements.datafocus.length != null) {
          // console.debug(sensors);
          this.buildChart(sensors);
        }
      });
    },
    getUpdateData (id, width, from, to, sensors) {
      const filter = sensors.map((_sens, index) => {
        const sens = _sens;
        sens.i = index;
        return sens;
      }).filter(x => x.selected);

      const sens = filter.map(x => x.name);
      const indexs = filter.map(x => x.i);
      const params = qs.stringify({
        id,
        width,
        sensors: sens,
        from,
        to,
      }, { arrayFormat: 'indices' });

      this.$api.$get(`/v1${this.params.loadDataUrl}/?${params}`).then((retdata) => {
        if (retdata != null && retdata[0] != null && retdata[0][0] != null) {
          const data = Array(retdata.length);
          retdata.forEach((item, i) => {
            data[i] = Array(sensors.length + 1).fill(null);
            [data[i][0]] = item;
            indexs.forEach((j, k) => {
              if (this.isNumeric(item[k + 1])) {
                data[i][j + 1] = item[k + 1];
              } else {
                data[i][j + 1] = null;
              }
            });
          });
          this.elements.datafocus = [].concat(
            this.elements.datacontext.filter(v => v[0] < retdata[0][0]),
            data,
            this.elements.datacontext.filter(v => v[0] > retdata[retdata.length - 1][0]),
          );
        }

        if (this.elements.datafocus != null && this.elements.datafocus.length != null) {
          this.updateChart(sensors);
        }
        if (this.elements.z > 1) {
          this.elements.z = 1;
          setTimeout(() => {
            this.getUpdateData(this.selectedItems().id, this.seriesWidth, this.elements.from, this.elements.to, this.selectedItems().axis);
          }, 5);
        } else {
          this.elements.z = 0;
        }
      });
    },
    createAxisY (sensor) {
      let delIndex = false;

      if (sensor.selected) {
        // console.debug(this.ArrayAxisY);
        // console.debug(sensor);
        this.ArrayAxisY[this.ArrayAxisY.length] = sensor.index;
        // console.debug(this.ArrayAxisY);
        if (this.ArrayAxisY.length > 4) {
          return;
        }
        delIndex = true;
      } else {
        // console.debug(this.ArrayAxisY); // последняя ок строка
        this.ArrayAxisY = this.ArrayAxisY.filter((item, i) => {
          if (item !== sensor.index) {
            return true;
          }
          if (i < 4) {
            delIndex = true;
          }
          return false;
        });
        // console.debug(this.ArrayAxisY); // здесь добавило undefiend
      }
      if (delIndex) {
        this.svg.selectAll('g.axis.axis--y').remove();
        const sensors = this.selectedItems().axis;
        // console.debug(this.ArrayAxisY);
        const arrayItemAxis = this.ArrayAxisY.filter((x, i) => i < 4);
        // console.debug(arrayItemAxis);
        arrayItemAxis.forEach((x, i) => {
          this.addAxis(sensors[x], x + 1, i + 1);
        });
      }
    },
    addAxis (sensor, index, i) {
      // console.debug('addAxis');
      const y1 = d3.scaleLinear().range([this.height, 0]);
      const y1m = d3.scaleLinear().range([this.height2, 0]);

      const yAxis1 = (i === 1 || i === 4) ? d3.axisLeft(y1) : d3.axisRight(y1);
      let min;
      let max;
      if (sensor && sensor.groupIndex != null) {
        const group = this.selectedItems().axis.filter(x => x.groupIndex != null && x.groupIndex === sensor.groupIndex);
        min = d3.min(group.map(x => d3.min(this.elements.datafocus.filter(v => v[x.index + 1] != null), d => d[x.index + 1])));
        max = d3.max(group.map(x => d3.max(this.elements.datafocus.filter(v => v[x.index + 1] != null), d => d[x.index + 1])));
      } else {
        min = d3.min(this.elements.datafocus.filter(v => v[index] != null), d => d[index]);
        max = d3.max(this.elements.datafocus.filter(v => v[index] != null), d => d[index]);
      }
      const add2axis = (max - min) * 0.02; // добавляем по 2% к шкалам сверху и снизу, чтобы не затирались минимальные и максимальные значения
      y1.domain([min - add2axis, max + add2axis]);
      y1m.domain(y1.domain());

      const yAxisPLase = this.elements.focus.select('.yAxises');
      if (i === 1 || i === 3) {
        const gAxis = yAxisPLase.append('g') // Ось Y
          .attr('class', 'axis axis--y')
          .call(yAxis1);
        if (sensor) {
          this.colorizeAxis(gAxis, sensor.color);
        }
      }
      if (i === 2 || i === 4) {
        const gAxis = yAxisPLase.append('g') // Ось Y
          .attr('class', 'axis axis--y')
          .attr('transform', `translate(${this.seriesWidth}, 0)`)
          .call(yAxis1);
        if (sensor) {
          this.colorizeAxis(gAxis, sensor.color);
        }
      }
    },
    addSeries (_sensor, index) {
      const sensor = _sensor;
      if (this.elements.datafocus.length > 0 && this.elements.datafocus[0].length <= index) { // проверяем, есть ли данные в наборе
        return;
      }
      const y1 = d3.scaleLinear().range([this.height, 0]);
      const y1m = d3.scaleLinear().range([this.height2, 0]);

      const line1 = d3.line()
        .x(d => this.x(new Date(d[0] * 1000 + this.reportTime)))
        .y(d => y1(d[index]));

      sensor.line = line1;
      sensor.y1 = y1;
      const line1M = d3.line()
        .x(d => this.xm(new Date(d[0] * 1000 + this.reportTime)))
        .y(d => y1m(d[index]));
      let min;
      let max;
      if (sensor && sensor.groupIndex != null) {
        const group = this.selectedItems().axis.filter(x => x.groupIndex != null && x.groupIndex === sensor.groupIndex);
        min = d3.min(group.map(x => d3.min(this.elements.datafocus.filter(v => v[x.index + 1] != null), d => d[x.index + 1])));
        max = d3.max(group.map(x => d3.max(this.elements.datafocus.filter(v => v[x.index + 1] != null), d => d[x.index + 1])));
      } else {
        min = d3.min(this.elements.datafocus.filter(v => v[index] != null), d => d[index]);
        max = d3.max(this.elements.datafocus.filter(v => v[index] != null), d => d[index]);
      }
      const add2axis = (max - min) * 0.02; // добавляем по 2% к шкалам сверху и снизу, чтобы не затирались минимальные и максимальные значения
      y1.domain([min - add2axis, max + add2axis]);
      y1m.domain(y1.domain());

      if (this.elements != null) {
        const ph = this.elements.focus.select('.seriesPlace');
        if (sensor) {
          ph.append('path') // Основная линия
            .datum(this.elements.datafocus.filter(item => item[index] != null))
            .attr('class', `line${index}`)
            .style('stroke', sensor.color)
            .style('clip-path', `url(#clip${this.params.svgName})`)
            .style('fill', 'none')
            .style('stroke-width', '2')
            .style('shape-rendering', 'crispEdges')
            .attr('d', line1);

          this.elements.context.append('path') // Миникарта
            .attr('class', `minicard${index}`)
            .datum(this.elements.datacontext.filter(item => item[index] != null))
            .style('stroke', sensor.color)
            .style('clip-path', `url(#clip${this.params.svgName})`)
            .style('fill', 'none')
            .style('stroke-width', '1')
            .style('shape-rendering', 'crispEdges')
            .attr('d', line1M);
        }
      }
    },
    updateFocusSeries (_sensor, index) {
      const sensor = _sensor;
      const ph = this.elements.focus.select('.seriesPlace');

      // удаляем основную линию
      ph.selectAll(`.line${index}`).remove();

      const line1 = d3.line()
        .x(d => this.x(new Date(d[0] * 1000 + this.reportTime)))
        .y(d => sensor.y1(d[index]));
      sensor.line = line1;
      if (sensor) {
        ph.append('path') // Основная линия
          .datum(this.elements.datafocus.filter(item => item[index] != null))
          .attr('class', `line${index}`)
          .style('stroke', sensor.color)
          .style('clip-path', `url(#clip${this.params.svgName})`)
          .style('fill', 'none')
          .style('stroke-width', '2')
          .style('shape-rendering', 'crispEdges')
          .attr('d', line1);
      }
      this.visibleElements(sensor, index);
    },
    visibleElements (sensor, index) {
      const ph = this.elements.focus.select('.seriesPlace');

      if (sensor.selected) {
        // отображаем элементы
        ph.selectAll(`.line${index}`)
          .style('display', 'block');
        this.svg.selectAll(`path.minicard${index}`)
          .style('display', 'block');
        if (this.ArrayAxisY.length !== 0) {
          this.svg.select('.ImageDrainsFills').style('display', 'block');
          this.svg.style('display', 'block');
        }
      } else {
        // скрываем элементы
        ph.selectAll(`.line${index}`)
          .style('display', 'none');
        this.svg.selectAll(`path.minicard${index}`)
          .style('display', 'none');
        if (this.ArrayAxisY.length === 0) {
          this.svg.select('.ImageDrainsFills').style('display', 'none');
          this.svg.style('display', 'none');
        }
      }
    },
    // Возвращает преобразованные данные из retdata в формат данных для self.elements.datacontext и self.elements.datafocus
    copyIntervalData (filter, retdata, k, sens) {
      let t = 0;
      let s = 0;
      let format = 0;
      const data = Array(filter.length > retdata.length ? filter.length : retdata.length);
      filter.forEach((item) => {
        while (t < retdata.length && item[0] > retdata[t][0]) {
          data[s] = Array(item.length).fill(null);
          [data[s][0], data[s][k]] = retdata[t];
          s += 1;
          t += 1;
        }
        data[s] = Array(item[0].length).fill(null);
        item.forEach((x, j) => {
          if (j === k) {
            if (t < retdata.length && item[0] === retdata[t][0]) {
              if (this.isNumeric(retdata[t][1])) {
                [, data[s][k]] = retdata[t];
              } else {
                data[s][k] = null;
                format += 1;
              }
              t += 1;
            } else {
              data[s][k] = null;
            }
          } else {
            data[s][j] = x;
          }
        });
        s += 1;
      });
      if (sens !== null) {
        if (format === retdata.length) {
          console.log(`Датчик ${sens[0]} имеет не числовой формат данных`);
        }
      }
      return data;
    },
    // Инициализация выбранной линии sensor на графике, на данном участке [0, 100]
    getInitLine (id, width, from, to, _sensor) {
      const sensor = _sensor;
      const sens = [sensor.name];
      const k = sensor.index + 1;
      const params = qs.stringify({
        id,
        width,
        sensors: sens,
        from,
        to,
      }, { arrayFormat: 'indices' });

      this.$api.$get(`/v1${this.params.loadDataUrl}/?${params}`).then((retdata) => {
        const data = this.copyIntervalData(this.elements.datacontext, retdata, k, sens);
        this.elements.datacontext = data;
        sensor.init = true;
        if (data.length !== null) {
          const mcard = this.elements.context.select(`.minicard${k}`);

          const y1 = d3.scaleLinear().range([this.height, 0]);
          const y1m = d3.scaleLinear().range([this.height2, 0]);
          const line1 = d3.line()
            .x(d => this.x(new Date(d[0] * 1000 + this.reportTime)))
            .y(d => y1(d[k]));
          sensor.line = line1;
          sensor.y1 = y1;
          const line1M = d3.line()
            .x(d => this.xm(new Date(d[0] * 1000 + this.reportTime)))
            .y(d => y1m(d[k]));
          const min = d3.min(this.elements.datacontext.filter(v => v[k] != null), d => d[k]);
          const max = d3.max(this.elements.datacontext.filter(v => v[k] != null), d => d[k]);
          const add2axis = (max - min) * 0.02;
          y1.domain([min - add2axis, max + add2axis]);
          y1m.domain(y1.domain());

          mcard.datum(this.elements.datacontext.filter(item => item[k] != null))
            .attr('d', line1M);
          this.getUpdateLine(this.selectedItems().id, this.seriesWidth, this.elements.from, this.elements.to, sensor);
        }
        return 1;
      });
    },
    // Обновление выбранной линии sensor на графике, на данном участке [from, to]
    getUpdateLine (id, width, from, to, sensor) {
      const sens = [sensor.name];
      const k = sensor.index + 1;
      const params = qs.stringify({
        id,
        width,
        sensors: sens,
        from,
        to,
      }, { arrayFormat: 'indices' });

      this.$api.$get(`/v1${this.params.loadDataUrl}/?${params}`).then((retdata) => {
        if (retdata != null && retdata[0] != null && retdata[0][0] != null) {
          const data = this.copyIntervalData(this.elements.datafocus.filter(v => v[0] >= retdata[0][0] && v[0] <= retdata[retdata.length - 1][0]), retdata, k, null);

          this.elements.datafocus = [].concat(
            this.elements.datacontext.filter(v => v[0] < retdata[0][0]),
            data,
            this.elements.datacontext.filter(v => v[0] > retdata[retdata.length - 1][0]),
          );
          const line = this.elements.focus.select('.seriesPlace').selectAll(`.line${k}`);
          line.datum(this.elements.datafocus.filter(item => item[k] != null))
            .attr('d', sensor.line);

          // console.debug('Обновление графика! Сенсор: ', sensor);
          this.createAxisY(sensor);
          this.visibleElements(sensor, k);
        }
      });
    },
    colorizeAxis (axis, color) {
      axis.selectAll('line').style('stroke', color);
      axis.selectAll('path').style('stroke', color);
      axis.selectAll('text').style('paint-order', 'stroke')
        .style('fill', color)
        .style('stroke', 'white')
        .style('stroke-width', '4');
    },
    GetDrainsFills () {
      // отрисовка областей поездок
      const ridesEvents = this.ImageDrainsFills.append('g').attr('class', 'RidesEvents');
      this.rides.forEach((item, i) => {
        const x1 = this.x(new Date(item.BeginDate + this.reportTime)) - this.sizeImage / 2;
        const x2 = this.x(new Date(item.EndDate + this.reportTime)) - this.sizeImage / 2;

        // fake-image - без добавления изображения не отображается
        ridesEvents.append('image')
          .attr('class', 'ride')
          .attr('x', x1)
          .attr('y', 5 - this.margin.top);

        ridesEvents.append('rect')
          .attr('class', 'ridesEvents')
          .attr('id', `ride${i}`)
          .attr('x', x1)
          .attr('y', 0)
          .attr('width', x2 - x1)
          .attr('height', this.height)
          .style('cursor', 'ew-resize')
          .style('fill', 'green')
          .style('opacity', 0.15)
          .style('pointer-events', 'all')
          .style('clip-path', `url(#clip${this.params.svgName})`);
      });

      // отрисовка значков сливов и их областей
      const imageDrains = this.ImageDrainsFills.append('g').attr('class', 'ImageDrains');
      this.drains.forEach((item, i) => {
        const x1 = this.x(new Date(item.BeginDate + this.reportTime)) - this.sizeImage / 2;
        const x2 = this.x(new Date(item.EndDate + this.reportTime)) - this.sizeImage / 2;

        imageDrains.append('image')
          .attr('class', 'drains')
          .attr('x', x1)
          .attr('y', 5 - this.margin.top)
          .attr('width', this.sizeImage)
          .attr('height', this.sizeImage)
          .attr('xlink:href', '/img/icon_fuel/drain.png');

        imageDrains.append('rect')
          .attr('class', 'drainsRect')
          .attr('id', `drain${i}`)
          .attr('x', x1 + this.sizeImage / 2)
          .attr('y', 0)
          .attr('width', x2 - x1)
          .attr('height', this.height)
          .style('cursor', 'ew-resize')
          .style('fill', '#dc0000')
          .style('opacity', 0.3)
          .style('pointer-events', 'all')
          .style('clip-path', `url(#clip${this.params.svgName})`);
      });

      // отрисовка значков заправок и их областей
      const imageFills = this.ImageDrainsFills.append('g').attr('class', 'ImageFills');
      this.fills.forEach((item, i) => {
        const x1 = this.x(new Date(item.BeginDate + this.reportTime)) - this.sizeImage / 2;
        const x2 = this.x(new Date(item.EndDate + this.reportTime)) - this.sizeImage / 2;

        imageFills.append('image')
          .attr('class', 'fills')
          .attr('x', x1)
          .attr('y', 5 - this.margin.top)
          .attr('width', this.sizeImage)
          .attr('height', this.sizeImage)
          .attr('xlink:href', '/img/icon_fuel/fill.png');

        imageFills.append('rect')
          .attr('class', 'fillsRect')
          .attr('id', `fill${i}`)
          .attr('x', x1 + this.sizeImage / 2)
          .attr('y', 0)
          .attr('width', x2 - x1)
          .attr('height', this.height)
          .style('cursor', 'ew-resize')
          .style('fill', '#0046bd')
          .style('opacity', 0.3)
          .style('pointer-events', 'all')
          .style('clip-path', `url(#clip${this.params.svgName})`);
      });

      // отрисовка областей отсутствия события
      const noinfoEvents = this.ImageDrainsFills.append('g').attr('class', 'NoInfo');
      this.noinfo.forEach((item, i) => {
        const x1 = this.x(new Date(item.BeginDate + this.reportTime)) - this.sizeImage / 2;
        const x2 = this.x(new Date(item.EndDate + this.reportTime)) - this.sizeImage / 2;

        // fake-image - без добавления изображения не отображается
        noinfoEvents.append('image')
          .attr('class', 'no-info')
          .attr('x', x1)
          .attr('y', 5 - this.margin.top);

        noinfoEvents.append('rect')
          .attr('class', 'noinfoEvents')
          .attr('id', `noinfo${i}`)
          .attr('x', x1)
          .attr('y', 0)
          .attr('width', x2 - x1)
          .attr('height', this.height)
          .style('cursor', 'ew-resize')
          .style('fill', 'grey')
          .style('opacity', 0.3)
          .style('pointer-events', 'all')
          .style('clip-path', `url(#clip${this.params.svgName})`);
      });
    },
    UpdateImage () {
      // пересчет координат заправок
      this.svg.select('.ImageFills').selectAll('image.fills')._groups[0].forEach((_item, i) => {
        const item = _item;
        const x1 = this.x(new Date(this.fills[i].BeginDate + this.reportTime)) - this.sizeImage / 2;
        const x2 = this.x(new Date(this.fills[i].EndDate + this.reportTime)) - this.sizeImage / 2;
        if (!(x1 >= -this.sizeImage / 2 && x1 <= (this.seriesWidth - this.sizeImage / 2))) {
          item.attributes.x.value = -100;
        } else {
          item.attributes.x.value = x1;
        }
        this.svg.select(`rect#fill${i}`)._groups[0][0].attributes.x.value = x1 + this.sizeImage / 2;
        this.svg.select(`rect#fill${i}`)._groups[0][0].attributes.width.value = x2 - x1;
      });
      // пересчет координат сливов
      this.svg.select('.ImageDrains').selectAll('image.drains')._groups[0].forEach((_item, i) => {
        const item = _item;
        const x1 = this.x(new Date(this.drains[i].BeginDate + this.reportTime)) - this.sizeImage / 2;
        const x2 = this.x(new Date(this.drains[i].EndDate + this.reportTime)) - this.sizeImage / 2;
        if (!(x1 >= -this.sizeImage / 2 && x1 <= (this.seriesWidth - this.sizeImage / 2))) {
          item.attributes.x.value = -100;
        } else {
          item.attributes.x.value = x1;
        }
        this.svg.select(`rect#drain${i}`)._groups[0][0].attributes.x.value = x1 + this.sizeImage / 2;
        this.svg.select(`rect#drain${i}`)._groups[0][0].attributes.width.value = x2 - x1;
      });

      // пересчет координат поездок
      this.svg.select('.RidesEvents').selectAll('.ridesEvents')._groups[0].forEach((_item, i) => {
        const item = _item;
        const x1 = this.x(new Date(this.rides[i].BeginDate + this.reportTime)) - this.sizeImage / 2;
        const x2 = this.x(new Date(this.rides[i].EndDate + this.reportTime)) - this.sizeImage / 2;
        if (!(x1 >= -this.sizeImage / 2 && x1 <= (this.seriesWidth - this.sizeImage / 2))) {
          item.attributes.x.value = -100;
        } else {
          item.attributes.x.value = x1;
        }
        this.svg.select(`rect#ride${i}`)._groups[0][0].attributes.x.value = x1 + this.sizeImage / 2;
        this.svg.select(`rect#ride${i}`)._groups[0][0].attributes.width.value = x2 - x1;
      });

      // пересчет координат отсутствия события
      this.svg.select('.NoInfo').selectAll('.noinfoEvents')._groups[0].forEach((_item, i) => {
        const item = _item;
        const x1 = this.x(new Date(this.noinfo[i].BeginDate + this.reportTime)) - this.sizeImage / 2;
        const x2 = this.x(new Date(this.noinfo[i].EndDate + this.reportTime)) - this.sizeImage / 2;
        if (!(x1 >= -this.sizeImage / 2 && x1 <= (this.seriesWidth - this.sizeImage / 2))) {
          item.attributes.x.value = -100;
        } else {
          item.attributes.x.value = x1;
        }
        this.svg.select(`rect#noinfo${i}`)._groups[0][0].attributes.x.value = x1 + this.sizeImage / 2;
        this.svg.select(`rect#noinfo${i}`)._groups[0][0].attributes.width.value = x2 - x1;
      });
    },
    updateChart (sensors) {
      const resortedSensors = sensors.map((_sens, index) => {
        const sens = _sens;
        sens.index = index;
        return sens;
      });
      resortedSensors.sort(this.compareZIndex).map(item => this.updateFocusSeries(item, item.index + 1));
    },
    clearChart () {
      this.elements.focus.selectAll('g').remove();
      this.elements.focus.selectAll('path').remove();
      this.elements.context.selectAll('g').remove();
      this.elements.context.selectAll('path').remove();
      this.svg.selectAll('.zoom').remove();
    },
  },
};
</script>
<style lang="stylus" scoped>
  .wrap {
    position: relative;
  }
  path {
    fill: none;
    stroke: #76BF8A;
    stroke-width: 3px;
  }
  .tooltip {
    pointer-events: none;

    position: absolute;
    z-index: 1;

    min-width: 310px;
    max-width: 310px;
    padding: 5px;

    background: white;
    font: 16px roboto, sans-serif;
    box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.4);
  }
</style>
